import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toSlug } from "../utils/slug";
import { loadBlogs } from "../services/contentSource";
import Seo from "../components/Seo";

const Blogs = () => {
  const [blogSection, setBlogSection] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBlogs()
      .then((data) => {
        if (data) setBlogSection(data);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading...</p>;

  if (!blogSection) return <p>No blog data available</p>;

  return (
    <>
      <Seo
        title="Blog"
        description="Engineering notes on building and operating production AI systems from the MindSyncX team."
        path="/blogs"
      />
      <link rel="stylesheet" href="/assets/css/master-blog.css" />
      <main>
        {/* Featured section */}
        <section className="featured-area">
          <div className="container">
            <div className="featured-area-inner">
              <div className="section-content">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h1 className="section-title large has_fade_anim">
                      {blogSection.title}
                    </h1>
                  </div>
                </div>
                <div className="text-box">
                  <div className="text-wrapper">
                    <p className="text has_fade_anim">
                      {blogSection.description}
                    </p>
                  </div>
                  <div className="counter-box has_fade_anim">
                    <div className="counter-item">
                      <span className="number wc-counter">{blogSection.counters.totalPosts}</span>
                      <p className="text">Total Posts</p>
                    </div>
                    <div className="counter-item">
                      <span className="number wc-counter">{blogSection.counters.blogWriters}</span>
                      <p className="text">Blog Writers</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Featured Posts */}
        <div className="featured-post-area">
          <div className="container">
            <div className="featured-post-box">
              <div className="featured-posts">
                {blogSection.featuredPosts.map((post: any, idx: number) => (
                  <article
                    className="blog-box has_fade_anim"
                    key={post._id}
                    data-delay={`0.${(idx + 1) * 15}`}
                  >
                    <Link
                      to={`/blogs/${toSlug(post.title, post.blogId)}`}
                      style={{ cursor: "pointer", display: "block" }}
                    >
                      <div className="thumb">
                        <img src={post.img} alt={post.title} loading="lazy" decoding="async" />
                      </div>
                      <div className="content">
                        <div className="content-first">
                          <h2 className="title">{post.title}</h2>
                          <span className="tag">
                            Featured Post <br />
                            {post.date}
                          </span>
                        </div>
                        <div className="icon">
                          <i className="fa-solid fa-arrow-right" />
                        </div>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Blog Cards Section */}
        <section className="blog-area">
          <div className="container">
            <div className="blog-area-inner section-spacing">
              <div className="section-content">
                <div className="section-title-wrapper">
                  <div className="title-wrapper">
                    <h2 className="section-title has_fade_anim">
                      {blogSection.seriesTitle}
                    </h2>
                  </div>
                </div>
                <div className="text-wrapper">
                  <p className="text has_fade_anim">
                    {blogSection.seriesDescription}
                  </p>
                </div>
              </div>

              <div className="blogs-wrapper-box">
                <div className="blogs-wrapper has_fade_anim">
                  {blogSection.blogs.map((blog: any) => (
                    <Link
                      to={`/blogs/${toSlug(blog.title, blog.blogId)}`}
                      key={blog._id}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="blog-box">
                        <div className="thumb">
                          <img src={blog.img} alt={blog.title} loading="lazy" decoding="async" />
                        </div>
                        <div className="content">
                          <span className="number">{blog.number}</span>
                          <h3 className="title">{blog.title}</h3>
                          <span className="icon">
                            <i className="fa-solid fa-arrow-right" />
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Blogs;
